/* ===========================================================================
   WARA body scroll lock — ONE implementation for every overlay.

   Why this exists. The shared rule `body.wara-drawer-open { position: fixed;
   width: 100% }` lives in sections/wara-header.liquid but cascades to every
   consumer of that class. position:fixed pulls the body out of flow, so the
   document collapses to viewport height and the browser resets scrollY to 0.
   Measured on a collection page: scrollHeight 3069 -> 900, scrollY 1400 -> 0.

   The header's nav drawer always compensated for this (save scrollY, offset the
   body by -scrollY, restore on unlock). snippets/wara-cart-drawer.liquid and the
   filter sheet in snippets/wara-filter-bar.liquid did NOT — they toggled the
   class raw — which is why adding to cart on desktop threw the page to the top
   while the nav drawer behaved. Rather than copy the fix a third time, all three
   now call this.

   Refcounted, because overlays can legitimately nest (a cart drawer opened from
   the nav drawer). Only the outermost lock saves and restores the position.

   Consumers must keep a fallback to the raw class toggle: this loads deferred
   from layout/theme.liquid, and an overlay must still be usable if it 404s.
   =========================================================================== */
(function () {
  'use strict';

  var CLASS = 'wara-drawer-open';
  var depth = 0;
  var savedY = 0;

  function lock() {
    if (depth++ > 0) return;                  // an outer overlay already locked
    savedY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + savedY + 'px';
    document.body.classList.add(CLASS);
  }

  function unlock() {
    if (depth === 0) return;                  // never go negative on a stray unlock
    if (--depth > 0) return;                  // an outer overlay is still open
    document.body.classList.remove(CLASS);
    document.body.style.top = '';
    /* CSS scroll-behavior applies to programmatic scrollTo, so a smooth-scroll
       theme would animate the restore and be visible as a lurch. Force it
       instant for this one write. */
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    html.style.scrollBehavior = prev;
  }

  /* Escape hatch for a consumer that has lost track (e.g. the filter sheet when
     the viewport leaves sheet mode while open) and needs the page released
     regardless of depth. */
  function reset() {
    depth = 0;
    document.body.classList.remove(CLASS);
    document.body.style.top = '';
  }

  function isLocked() { return depth > 0; }

  window.waraScrollLock = { lock: lock, unlock: unlock, reset: reset, isLocked: isLocked };
})();
